import { QueryClient } from '@tanstack/react-query'

/**
 * Cliente único de React Query de la aplicación.
 * Lo usa `QueryClientProvider` en main.tsx y las utilidades que trabajan fuera de React
 * (ej. `invalidateQuery`), para que todos compartan la misma caché.
 * Dentro de componentes y hooks se puede seguir usando `useQueryClient()`.
 * @author isi-template
 */
export const queryClient = new QueryClient()
